export const GENERAL_NOTIFICATION = 'general';
export const STORE_PUBLICITY = 'StorePublicity';
export const BROADCAST = 'BroadCast';
